import { TitleTestEnum } from 'src/utils/enum';

export const CreationTestTitle = 'Создание опроса';

export const CreationTestBreds = [
  {
    name: 'Главная страница',
    pathname: '/',
  },
  {
    name: 'Создание опроса',
    pathname: '',
    isActive: true,
  },
];

export const CreationQuestionBreds = [
  {
    name: 'Главная страница',
    pathname: '/dashboard',
  },
  {
    name: 'Создание опроса',
    isProps: true,
    pathname: '',
  },
  {
    name: 'Добавление вопроса',
    pathname: '',
    isActive: true,
  },
];

export const CreationTestTabs = [
  {
    name: 'Настройки',
    id: 'settings',
  },
  {
    name: 'Содержание',
    id: 'сontent',
  },
];

export const TestFormTitle = 'Выбор категории';

export const TestFormName = 'Название опроса';

export const TestFormNameTags = 'Теги';

export const TestFormNameHello = 'Приветственная страница';

export const TestFormNameThank = 'Страница «Cпасибо»';

export const TestFormTooltipText =
  'Опрос\u00A0- категория, которая позволяет проводить опросы для сбора информации и\u00A0обучения.\n\nТест\u00A0- категория, которая позволяет проводить тестирования и\u00A0подсчитывать количество баллов за\u00A0правильные ответы';

export const TestFormTooltipTextTrueAnswers =
  'Прошедший тест увидит правильный ответ на каждый вопрос в своем личном кабинете';

export const TestFormTooltipTextScoreAnswers =
  'Прошедший тест увидит количество полученных баллов за каждый вопрос';

export const TestFormTooltipTextTags =
  'Выберите или введите не более трех тегов';

export const TestFormTooltipTextCalendars =
  'Позволят настроить автоматическую публикацию и завершения опроса.\n\nВозможна задержка от назначенного времени до 5 минут.';

export const NotQuestion = 'Вы еще не добавили ни одного вопроса';

export const CreationTestTextModal =
  'У\u00A0вас есть несохраненные изменения. Вы\u00A0уверены, что хотите покинуть страницу?';

export const QuestionCreationName = 'Текст вопроса';

export const QuestionTooltipTextRight =
  'Проходящий опрос сможет оставить комментарий';

export const QuestionTooltipTextComment =
  'Данные опроса будут участвовать в\u00A0аналитике и\u00A0будут отображены в\u00A0отчете';

export const QuestionPossibleAnswertext = 'Вариант ответа';

export const QuestionPossibleAnswerName = 'Название поля';

export const QuestionPossibleAnswerSlider = 'Параметр оценки';

export const PublishTestTitle = 'Ваш опрос опубликован';

export const PublishTestText =
  'Теперь ты\u00A0можешь узнать больше и\u00A0получить ответы на\u00A0все свои вопросы. Не\u00A0забудь скопировать ссылку на\u00A0свой опрос.';

export const DeleteQuestionTextModal = 'Вы уверены, что хотите удалить вопрос?';

export const TestFormTooltipTest =
  'Укажите количество баллов для успешного прохождения теста. Максимальное количество баллов подсчитывается исходя из\u00A0количества баллов за\u00A0каждый вопрос';

export const TestFormTypeCounterFullText = 'Полное совпадение';

export const TestFormTypeCounterPartialText = 'Частичное совпадение';

export const QuestionScoreTooltipTest =
  'Укажите максимальное количество баллов, которое пользователь может получить за\u00A0правильный ответ';

export const SurveyItemShareTooltipText = 'Поделиться ссылкой';

export const SurveyItemDatePublished = 'Назначенная дата публикации';

export const SurveyItemDateEnded = 'Назначенная дата завершения';

export const CreateTestNewTitle = {
  id: TitleTestEnum.New,
  name: 'Создание опроса',
};

export const CreateTestEditTitle = {
  id: TitleTestEnum.Edit,
  name: 'Редактирование опроса',
};

export const ErrorPublishTitle = 'Невозможно опубликовать опрос';

export const ErrorPublishText =
  'Для того чтобы опубликовать опрос, вам необходимо заполнить следующее:';

export const ErrorPredPreviewTitle = 'Невозможно просмотреть опрос';

export const ErrorPredPreviewText =
  'Для того чтобы просмотреть опрос, вам необходимо заполнить следующее:';

export const DashboardWarningTitle = 'Не удалось создать опрос';

export const DashboardWarningText = 'Попробуйте загрузить другой файл';

export const DashboardImportSuccessTitle = 'Опрос успешно загружен';

export const DashboardDuplicatedWarningTitle = 'Не удалось дублировать опрос';

export const DashboardDeleteWarningTitle = 'Не удалось удалить опрос';

export const DashboardStatusWarningTitle = 'Не удалось изменить статус опроса';

export const DefaultRatingValue = 5;

export const hotKeys = {
  prevPage: {
    label: '',
    values: ['Alt', 'ArrowLeft'],
  },
  nextPage: {
    label: '',
    values: ['Alt', 'ArrowRight'],
  },
};
